import { Helmet } from "react-helmet-async";

const ProductSchema = ({ product, productImages }: { product: any, productImages: any[] }) => {
  if (!product) return null;

  const schema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.title,
    "image": productImages.map((img: any) => `${process.env.REACT_APP_IMAGE_URL}${img.original}`),
    "description": product.productDetailDescription?.replace(/<[^>]+>/g, '').slice(0, 300),
    "sku": product.SKU,
    "brand": {
      "@type": "Brand",
      "name": "SkyAzul"
    },
    "offers": {
      "@type": "Offer",
      "priceCurrency": "USD",
      "price": product.price,
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition",
      "url": `${window.location.origin}${window.location.pathname}`
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default ProductSchema;
